import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-toolbar-secondary',
  templateUrl: './toolbar-secondary.component.html',
  styleUrls: ['./toolbar-secondary.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarSecondaryComponent {}
